import Checkbox from './src/checkbox';

Checkbox.install = function(Vue) {
  Vue.component(Checkbox.name, Checkbox);
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/checkbox/index.js